import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ModalService } from '../../core/service/modal/modal.service';
import { Component } from '@angular/core';
import { AuthService } from '../../core/service/authentication/auth.service';
import { ApiResponseStatus } from '../../core/models/common/enums/api-response-status.enum';
import { LoaderService } from '../../core/service/loader/loader.service';
import ErrorResponse from '../../core/models/common/error-response.model';
import { NotificationService } from '../../core/service/notifications/notification.service';

@Component({
  selector: 'app-forgot-password-modal',
  templateUrl: './forgot-password-modal.component.html',
  styleUrls: ['./forgot-password-modal.component.scss']
})
export class ForgotPasswordModalComponent {

  passwordForgotForm: FormGroup = new FormGroup({
    emailAddress: new FormControl('', [Validators.required, Validators.email]),
  });

  constructor(
    private modalService: ModalService,
    private authService: AuthService,
    private loaderService: LoaderService,
    private notificationService: NotificationService) { }

  onForgot(): void {
    if (this.passwordForgotForm.invalid) return;

    const { emailAddress } = this.passwordForgotForm.value;

    this.loaderService.showLoader();
    this.authService.startRestorePassword(emailAddress).subscribe(
      (response) => {
        this.loaderService.hideLoader();
        if (response && response.status === ApiResponseStatus.Error) {
          const errorResponse = response.content as ErrorResponse;
          console.error(errorResponse);
          this.modalService.closeAllModals();
          this.notificationService.showError('Operation failed');
        } else {
          this.passwordForgotForm.reset();
          this.modalService.closeAllModals();
          this.notificationService.showSuccess('A message has been sent to your email address. Please confirm it before start to use GoGo Money Maker.');
        }
      }
    );
  }

  openRegisterModal() {
    this.modalService.openModal('register');
  }

}
